import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./index.css";
import "./styles/App.css";

import Contact from "./pages/Contact";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Unsubscribe from "./pages/Unsubscribe";
import Posters from "./pages/Posters";

// npm start
// ctrl+c to end
// git add .
// git commit -m "message"
// git push origin main
// npm run build
// firebase deploy

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/posters" element={<Posters />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
